<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="true"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-8">
        <ol class="breadcrumb" style="margin-top: 20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item active">Список полів</li>
        </ol>
      </div>
      <div class="col-4" v-if="currentField.type">
        <div class="p-t-10 position-fixed" style="right: 40px">
          <button @click="settings.push({name:''})" class="btn btn-success" style="font-size: 15px;letter-spacing: -0.3px;">Додати<br>налаштування</button>
        </div>
      </div>
    </div>

    <b-card>
      <b-tabs content-class="mt-3" nav-class="flex-nowrap" active-nav-item-class="h-100" fill>
        <b-tab lazy @click="orderBy('');searchName = null;getSettings(fields.filter(el=>type.type == el.type)[0].field)" v-for="type in [{type:false,name:'Динамічні'},{type:true,name:'Фіксовані'}]" :key="'dyn-tab-' + type.type" :title="type.name" :active="type.type == false">
        <b-tabs content-class="mt-3" nav-class="flex-nowrap" active-nav-item-class="h-100" fill>
          <b-tab @click="orderBy('');getSettings(item.field)" v-for="item in fields.filter(el=>el.type == type.type)" :key="'dyn-tab-' + item.field" :title="item.name" :active="item.field == 'isbn'">
                <div class="container-fluid">
                  <div class="row m-t-30 m-b-30" v-if="!currentField.type">
                    <div class="col-6">
                      <b-form-input v-model="searchName" @input="getSettings(currentField.field)" placeholder="Пошук" type="search"></b-form-input>
                    </div>
                    <div class="col-6">
                      <date-picker v-model="dateFilter" range @input="getSettings(currentField.field)"></date-picker>
                    </div>
                  </div>
                  <div class="row">
                    <table class="table reader table-books">
                      <thead>
                      <tr>
                        <th class="w-5">
                          ID
                        </th>
                        <th @click="orderBy('name')">
                          Заголовок
                          <i v-if="order.field == 'name' && order.sort == 'asc'" class="mdi mdi-sort-ascending"></i>
                          <i v-else-if="order.field == 'name' && order.sort == 'desc'" class="mdi mdi-sort-descending"></i>
                        </th>
                        <th class="w-10" @click="orderBy('created_at')">
                          Створенно
                          <i v-if="order.field == 'created_at' && order.sort == 'asc'" class="mdi mdi-sort-ascending"></i>
                          <i v-else-if="order.field == 'created_at' && order.sort == 'desc'" class="mdi mdi-sort-descending"></i>
                        </th>
                        <th class="w-10" @click="orderBy('updated_at')">
                          Оновлено
                          <i v-if="order.field == 'updated_at' && order.sort == 'asc'" class="mdi mdi-sort-ascending"></i>
                          <i v-else-if="order.field == 'updated_at' && order.sort == 'desc'" class="mdi mdi-sort-descending"></i>
                        </th>
                        <th class="w-10 text-center" @click="orderBy('descriptions_count')">
                          Описи
                          <i v-if="order.field == 'descriptions_count' && order.sort == 'asc'" class="mdi mdi-sort-ascending"></i>
                          <i v-else-if="order.field == 'descriptions_count' && order.sort == 'desc'" class="mdi mdi-sort-descending"></i>
                        </th>
                        <th class="w-10 text-center">
                          Функції
                        </th>
                      </tr>
                      </thead>
                      <draggable
                          :list="settings"
                          tag="tbody"
                          ghost-class="ghost"
                          :disabled="!currentField.type"
                          @end="changePosition()"
                      >
                        <tr v-for="(item,key) in settings">
                          <td>
                              <i v-if="currentField.type" class="mdi mdi-arrow-up-down-bold"></i>
                            {{ item.id }}
                          </td>
                          <td>
                            <div v-if="changeSettingId == item.id">
                              <b-form-input autofocus :state="item.name ? true : false" v-model="item.name" @blur="item.name ? (item.id ? updateSettings(item) : createSetting(item)) : ''"></b-form-input>
                            </div>
<!--                            <div @click="currentField.type ? changeSettingId = item.id : ''" v-else>-->
                            <div @click="doubleClick(item.id)" v-else>
                              <b>{{ item.title ? item.title : item.name }}</b>
                            </div>
                          </td>
                          <td>
                            {{ moment(item.created_at).format("YYYY-MM-DD hh:mm:ss") }}
                          </td>
                          <td>
                            {{ moment(item.updated_at).format("YYYY-MM-DD hh:mm:ss") }}
                          </td>
                          <td class="text-center">
                            <router-link target="_blank" v-if="item.descriptions_count && item.descriptions_count !=1" :to="{ name: 'descriptions', query: {filter:currentField.field, value:item.id}}" class="btn btn-success descriptions" >{{ item.descriptions_count }}</router-link>
                            <a href="#" v-if="item.descriptions_count && item.descriptions_count == 1" class="btn btn-success descriptions" @click="getDescription(item)">{{ item.descriptions_count }}</a>
                          </td>
                          <td class="text-center">
                            <b-button variant="danger" @click="deleteSetting(item.id)">
                              Видалити
                            </b-button>
                          </td>
                        </tr>
                      </draggable>
                    </table>
                  </div>
                  <div class="row" v-if="!currentField.type">
                    <div class="mr-auto">
                        <div class="m-t-10 p-t-30 m-l-30 footer-card">{{ settings.length }} із {{ total }}
                          записів
                        </div>
                    </div>
                    <div class="ml-auto">
                      <div class="m-t-10 p-t-30">
                            <b-pagination v-if="!currentField.type"
                                v-model="current_page"
                                :total-rows="total"
                                :per-page="perPage"
                                aria-controls="my-table"
                                @change="getSettings(currentField.field,$event)"
                            ></b-pagination>
                        <b-form-input type="number" @input="getSettings(currentField.field,$event)/*current_page = $event*/"></b-form-input>
                      </div>
                    </div>
                  </div>
            </div>
          </b-tab>
        </b-tabs>
        </b-tab>
      </b-tabs>
    </b-card>

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';

import draggable from 'vuedraggable'

export default {
  name: "Index",
  components:{
    Loading,draggable,DatePicker
  },
  mounted() {
    this.getSettings(this.currentField.field);
  },
  data(){
    return{
      isLoading:false,
      fields:[
        {field:'isbn', type: false, name:'ISBN'},
        {field:'author', type: false, name:'Автор'},
        {field:'coauthors', type: false, name:'Співавтор'},
        {field:'translators', type: false, name:'Перекладач'},
        {field:'illustrators', type: false, name:'Автор Ілюстрацій'},
        {field:'thematics', type: false, name:'Тематичні рубрики'},
        {field:'key_words', type: false, name:'Ключові слова'},
        {field:'publication',type: false,name:'Видавництво'},
        {field:'publication_name',type: false,id:2,name:'Назва видання (Періодичне видання)'},
        {field:'publication_name1',type: false,id:3,name:'Назва видання (Багатотомник/Комплект)'},
        // {field:'location_publication', type: false,name:'Місце видання'},
        {field:'type_record', type: true,name:'Тип запису (фіксована)'},
        {field:'rubric', type: true,name:'Основна рубрика (фіксована)'},
        {field:'languages', type: true,name:'Мова (фіксована)'},
      ],
      dateFilter:null,
      searchName:null,
      currentField:{field:'isbn', type: false, name:'ISBN'},
      settings:[],
      current_page:1,
      perPage:50,
      total:0,
      lastPage:1,
      changeSettingId:null,
      order:{
        field:null,
        sort:null
      },
      click:0,
      delay:700
    }
  },
  methods:{
    getDescription(item){
      axios.get('/library/settings/' + item.id + '?type=' + this.currentField.field + '&').then(res=>{
              let url = this.$router.resolve({name:'descriptionEdit', params:{id:res.data.data.descriptions[0].id}});
              console.log(url);
              window.open(url.href, '_blank');
          });
    },
    doubleClick(item){
      this.clicks++;
      if(this.clicks === 1){
        setTimeout(() => {
          this.clicks = 0
        }, this.delay);
      }else{
        // this.filterValue = {id:item.id};
        // this.getDescriptions();
        this.clicks = 0
        this.changeSettingId = item;
      }
    },
    orderBy(field){
      if(field == ''){
        this.order.field = null;
        this.order.sort = null;
        this.dateFilter = null;
      } else{
        if(!this.currentField.type){
          this.order.field = field;
          this.order.sort = this.order.sort == null || this.order.sort == 'desc' ? 'asc' : 'desc';
          this.getSettings(this.currentField.field);
        }
      }
    },
    changePosition(){
      let list = this.settings.map(el=> el.id);
      axios({
        method:'post',
        url:'/library/settings/change-position',
        data:{list, model:this.currentField.field}
      }).then(res=>{
        this.getSettings(this.currentField.field);
      });
    },
    getSettings(field, event){
      this.isLoading = true;
      this.currentField = this.fields.find(el => el.field == field);

      axios.get('/library/settings', {params:{
          field: field == 'publication_name1' ? 'publication_name' : field,
          page:event,
          orderField:this.order.field,
          orderSort:this.order.sort,
          name:this.searchName,
          dateFilter:(this.dateFilter && this.dateFilter[0] ? this.dateFilter : null),
          search:true,
          type_record_id: field == 'publication_name' || field == 'publication_name1' ? this.currentField.id : ''
        }}).then(response => {
          this.settings = response.data.data;
          this.current_page = response.data.current_page;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;
          this.total = response.data.total;
          this.isLoading = false;
      });
    },
    createSetting(item){
      axios({
        url:'/library/settings',
        method:'post',
        data:{
          name:item.name,
          type:this.currentField.field
        }
      }).then(()=>{
        this.getSettings(this.currentField.field);
      });
    },
    updateSettings(item){
      this.changeSettingId = null;
      axios({
        url: '/library/settings/' + item.id,
        data:{
          name:item.name,
          type:this.currentField.field
        },
        method:'put'
      }).then(() => {
        this.getSettings(this.currentField.field,this.current_page);
      })
    },
    deleteSetting(id){
      Swal.fire({
        title: 'Видалити налаштування',
        type: 'warning',
        text: "Для підтвердження напишіть ВИДАЛИТИ",
        input:'text',
        showCancelButton: true,
        // showConfirmButton:false,
        inputValidator:(value) => {
          if(value !== 'ВИДАЛИТИ'){
            return "Для підтвердження напишіть ВИДАЛИТИ"
          }
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Так, видалити',
        cancelButtonText: 'Ні'
      }).then((result) => {
        if (result.value) {
          axios({
            method: 'delete',
            url: '/library/settings/' + id,
            data:{type:this.currentField.field}
          }).then(response => {
            if(response.data.status === 'success'){
              this.getSettings(this.currentField.field, this.lastPage == this.current_page && this.settings.length == 1 ? this.current_page - 1 : this.current_page);
              Swal.fire(
                  'Видалено!',
                  '',
                  'success'
              )
            }else{
              Swal.fire(
                  'Не видалено! Є зв\'язок',
                  response.data.message,
                  'warning'
              )
            }
          });

        }
      })
    },
    moment: function (date) {
      return moment(date);
    },
  },
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.btn.descriptions{
  height:38px;
  width:100px;
  color:white;
}
.container-fluid >>> .mx-input{
  height:38px;
}

</style>